import axios from 'axios';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import useCotizacion from 'src/hooks/useCotizacion';
import { setCotizacion } from 'src/reducers/Cotizacion/cotizacion.actions';
import { urlSetBeneficiarios, urlcalcularVigenciaPoliza } from 'src/services/urls';
import BeneficiarioItem from './BeneficiarioItem';
import { StyledActionButton } from './styleds';

const ModalDeleteBeneficiario = ({ beneficiario, index }) => {
  const { cotizacion, idCotizacion } = useCotizacion();
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [eliminando, setEliminando] = useState(false);
  // const { addErrorToast } = useCustomToast();

  const onHide = () => {
    setShow(!show);
  };

  const onClickEliminar = async () => {
    setEliminando(true);
    const { beneficiarios } = cotizacion;
    const index = beneficiarios.indexOf(beneficiario);
    beneficiarios.splice(index, 1);

    //axios.get(urlcalcularVigenciaPoliza(idCotizacion)).catch((e) => { } );
    // addErrorToast('Error calculando vigencia'),
    const res = await axios.post(
      urlSetBeneficiarios,
      JSON.stringify({ beneficiarios, idCotizacion }),
    );
    if (res?.data?.transaccion) {
      dispatch(setCotizacion(res?.data?.cotizacion));
      window.location.reload()
    }
    setEliminando(false);
    setShow(false);

  };
  return (
    <React.Fragment>
      <StyledActionButton
        type="button"
        //@ts-ignore
        variant="danger"
        onClick={onHide}
      >
        <i className="pi pi-times mr-2" />
        Eliminar
      </StyledActionButton>
      <Modal
        show={show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => { }}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4 className="modal__eliminar__titulo">Confirmación</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoadingWrapper
            loading={eliminando}
            principal="Eliminando beneficiario..."
            secundario="Espere por favor"
          >
            <h4>Esta seguro/a de eliminar este/a {cotizacion?.producto?.categoria?.CamposBeneficiariosInfo?.labelBeneficiarioBien ?? ''}?</h4>
            <BeneficiarioItem
              beneficiario={beneficiario}
              index={index}
              showHeader={false}
              showDelete={false}
            />
          </LoadingWrapper>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onHide} disabled={eliminando}>
            Cerrar
          </Button>
          <Button variant="danger" onClick={onClickEliminar} disabled={eliminando}>
            {eliminando && 'Eliminando...'}
            {!eliminando && 'Eliminar'}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ModalDeleteBeneficiario;
